import 'waypoints/lib/noframework.waypoints.js';
import { navbarHeight } from './variables.js';

(($) => {
  $(() => {
    const $tableOfContentsStart = $('.section--table-of-contents-start');

    if ($tableOfContentsStart.length) {
      const $tableOfContents = $tableOfContentsStart.find('.table-of-contents');
      const $card = $tableOfContents.children('.card');
      const $list = $card.children('ul');

      const $chapters = $tableOfContentsStart
        .nextUntil('.section--table-of-contents-end', '.section')
        .has('h1, h2, h3, h4, h5, h6');

      if ($chapters.length) {
        $chapters.addClass('section--table-of-contents-chapter');

        $tableOfContentsStart.add($chapters).wrapAll('<div class="position-relative"></div>');

        const listItemActiveClass = 'table-of-contents__item--active';

        const addListItem = (index, element) => {
          const $chapter = $(element);

          const $firstHeading = $chapter.find('h1, h2, h3, h4, h5, h6').first();

          const $li = $(
            `<li class="table-of-contents__item"><a href="#${$chapter.attr('id')}">${$firstHeading.text()}</a></li>`
          );

          if ($list.is(':empty')) $li.addClass(listItemActiveClass);

          $list.append($li);
        };

        $chapters.each(addListItem);

        $card.removeClass('d-none');

        const updateSticky = (fixed, bottom) => {
          $tableOfContents[fixed ? 'addClass' : 'removeClass']('table-of-contents--fixed')[
            bottom ? 'addClass' : 'removeClass'
          ]('table-of-contents--bottom');
        };

        const updateListItems = (index) => {
          $list.children().eq(index).addClass(listItemActiveClass).siblings().removeClass(listItemActiveClass);
        };

        new Waypoint({
          element: $chapters.first().get(0),
          handler(direction) {
            const fixed = direction === 'down';
            const bottom = false;

            updateSticky(fixed, bottom);
          },
          offset: navbarHeight,
        });

        new Waypoint({
          element: $chapters.last().get(0),
          handler(direction) {
            const fixed = direction === 'up';
            const bottom = !fixed;

            updateSticky(fixed, bottom);
          },
          offset() {
            return $chapters.last().outerHeight() * -1 + $tableOfContents.outerHeight() + navbarHeight;
          },
        });

        $chapters.each((index, element) => {
          new Waypoint({
            element,
            handler(direction) {
              if (direction === 'down') {
                updateListItems(index);
              }
            },
            offset: '30%',
          });

          new Waypoint({
            element,
            handler(direction) {
              if (direction === 'up') {
                updateListItems(Math.max(0, index - 1));
              }
            },
            offset: '70%',
          });
        });

        const resizeObserver = new ResizeObserver(() => {
          Waypoint.refreshAll();
        });

        resizeObserver.observe(document.body);
      }
    }
  });
})(jQuery);
